/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AuthorizedSignatoryDto = {
    salutation: AuthorizedSignatoryDto.salutation;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    email: string;
};
export namespace AuthorizedSignatoryDto {
    export enum salutation {
        MR = 'MR',
        MRS = 'MRS',
        OTHER = 'OTHER',
    }
}

